import img1 from '../../assets/img/product-image/product1.png'
import img2 from '../../assets/img/product-image/product2.png'
import img3 from '../../assets/img/product-image/product3.png'
export const CartData = [
   {
    icon_Name:"fa fa-trash",
    img:img1,
    title:"Handbag fringilla",
    price:"$65.00",
    Quantity:"Quantity",
    total:"$130.00"
    
   },
   {
    icon_Name:"fa fa-trash",
    img:img2,
    title:"Handbag fringilla",
    price:"$65.00",
    Quantity:"Quantity",
    total:"$130.00"
   },
   {
    icon_Name:"fa fa-trash",
    img:img3,
    title:"Handbag fringilla",
    price:"$65.00",
    Quantity:"Quantity",
    total:"$130.00"
   }
   
]